import {DayNightSelector} from './time-input.types';

export const createTimeSlots = (): string[] => {
  const getTimeInDropdownFormat = (date: Date): string => {
    const options: Intl.DateTimeFormatOptions = {
      hour: '2-digit',
      minute: '2-digit',
      hour12: true,
    };
    return date.toLocaleTimeString('en-GB', options);
  };

  const timeSlotIncrementsMins = 15;
  const timeSlotDateTime = new Date();
  const startDate = timeSlotDateTime.getDate();
  timeSlotDateTime.setHours(0);
  timeSlotDateTime.setMinutes(0);
  timeSlotDateTime.setSeconds(0);
  timeSlotDateTime.setMilliseconds(0);

  const slots = [];

  while (timeSlotDateTime.getDate() === startDate) {
    slots.push(getTimeInDropdownFormat(timeSlotDateTime).toUpperCase());
    timeSlotDateTime.setMinutes(timeSlotDateTime.getMinutes() + timeSlotIncrementsMins);
  }
  return slots;
};

export const convert24To12Hr = (timeHourIn24: number): number => {
  if (timeHourIn24 > 12) {
    return timeHourIn24 - 12;
  }

  if (timeHourIn24 === 0) {
    return 12;
  }
  return timeHourIn24;
};

export const convert12HrTo24Hr = (dayNightSelector: DayNightSelector, timeHourIn12: number): number => {
  if (dayNightSelector === DayNightSelector.AM) {
    if (timeHourIn12 === 12) {
      return 0;
    }
    return timeHourIn12;
  }

  if (timeHourIn12 < 12) {
    return timeHourIn12 + 12;
  }
  return 12;
};

export const is24hrPM = (timeHourIn24: number): boolean => {
  return timeHourIn24 >= 12;
};
